module.exports = __webpack_public_path__ + "media/images/hand-6e5e0367.png";